import React, { useEffect } from 'react'
import { Form, Modal } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import feedback from '../../../assets/img/notify.jpg';
import { useState } from 'react';
import { chatListBuyer, chatSearchBuyer, chatTaskListBuyer, readAllNotification } from '../../../Redux/Chats/action';
import { viewUserProfile } from '../../../Redux/User/action';
import { IMAGE_URL } from '../../../api';
import moment from 'moment';
import OneSignalReact from 'react-onesignal';
import InfiniteScroll from 'react-infinite-scroll-component';
import CallrateModal from '../../CallrateModal';
import { IoCall } from 'react-icons/io5';


const ChatsBuyer = () => {
    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);
    React.useEffect(() => {
        setShow(false);
    }, []);
    const params = useParams()
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [status, setStatus] = useState(1);
    const [user, setUser] = useState({});
    const [totalPageNumber, setTotalPageNumber] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const __search = (e) => {
        chatListBuyer(e?.target?.value)((response) => {
            if (response?.status && response?.data) {
                setData(response?.data?.data)
            }
        });
    }
    const statusChat = (e) => {
        if (e.target.checked) {
            setStatus(e.target.value)
        }
    }
    useEffect(() => {

        viewUserProfile()((response) => {
            if (response && response.status) {
                setUser(response?.data?.data[0])
            }
        });
        // chatSearchBuyer({ formData })((response) => {
        //     if (response && response.status) {
        //         setData(response?.data?.data)
        //     }
        // });

        chatTaskListBuyer(params?.id, page, 12)((response) => {
            if (response && response.status) {
                setData(response?.data?.data)
                setTotalPageNumber(response?.data?.total_pages)
                if ((data.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setPage(2)
            }
        });
    }, []);
    useEffect(() => {
        OneSignalReact.on('notificationDisplay', function (event) {
            const notification_data = event.data.status
            if (notification_data === "online message" || notification_data === "Task Completed") {
                chatTaskListBuyer(params?.id, page, 12)((response) => {
                    if (response && response.status) {
                        setData(response?.data?.data)
                    }
                });
            }
        });
    }, [])
    const handleClickUserTask = (task) => {
        readAllNotification(task?.id, true)((response) => {
        })
        navigate('/chat/', { state: { collection: task?.users_list[0]?.email + task?.task_details?.id + task?.task_details?.user_data[0]?.email + task?.task_details?.id, reciever: task?.users_list[0], task_detail: task?.task_details?.id, task_detail_id: task?.id } })
    }
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const paginate = () => {
        chatTaskListBuyer(params?.id, page, 12)((response) => {
            if (response.status) {
                if ((data.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setData(data.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Chats </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Chats</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='chat-sect'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <Form>
                                {['radio'].map((type) => (
                                    <div key={`inline-${type}`} className="text-center mb-5">
                                        <Form.Check
                                            inline
                                            label="Online"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-1`}
                                            className='online'
                                            onChange={(e) => statusChat(e)}
                                            value="1"
                                            defaultChecked
                                        />
                                        <Form.Check
                                            inline
                                            label="Offline"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-2`}
                                            className='offline'
                                            onChange={(e) => statusChat(e)}
                                            value="2"
                                        />
                                        <Form.Check
                                            inline
                                            label="Away"
                                            name="group1"
                                            type={type}
                                            id={`inline-${type}-3`}
                                            className='away'
                                            onChange={(e) => statusChat(e)}
                                            value="3"
                                        />

                                    </div>
                                ))}
                            </Form>
                        </div>
                        <div className='col-lg-12'>
                            <form className="search-form d-flex align-items-center justify-content-center" >
                                <input type="text" name="query" placeholder="Search buyer's name" title="Search" onChange={(e) => __search(e)} className='w-50' />
                                <button type="submit" title="Search">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <section className="chats section-bg p-0">
                <div className="container">
                    {status == 1 ?
                        <div className="row">
                            {data?.map((task, index) =>
                                <React.Fragment>
                                    {status == task?.users_list[0]?.status[0]?.status &&

                                        <div className="col-lg-3">
                                            <div className='chats-sec' onClick={() => navigate('/chat/' + task?.users_list[0]?.email + task?.task_details?.id + user?.user?.email + task?.task_details?.id, { state: { reciever: task?.users_list[0], task_detail: task?.task_details?.id } })} >
                                                <div className="member d-flex align-items-start">
                                                    <div className="pic"><img src={IMAGE_URL + task?.users_list[0]?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                    <div className="member-info">
                                                        <h4>{task?.task_details?.title}</h4>
                                                        <p>{task?.users_list[0]?.username}</p>
                                                    </div>
                                                    <div class="online-status"></div>
                                                </div>
                                            </div>
                                        </div>

                                    }
                                </React.Fragment>
                            )}
                        </div>
                        :
                        <div className="row">
                            {data?.map((task, index) =>
                                <React.Fragment>
                                    {status == task?.users_list[0]?.status[0]?.status &&
                                        <div className="col-lg-3">
                                            <div className='chats-sec' onClick={() => navigate('/chat/' + task?.users_list[0]?.email + task?.task_details?.id + user?.user?.email + task?.task_details?.id, { state: { reciever: task?.users_list[0], task_detail: task?.task_details?.id } })}>
                                                <div className="member d-flex align-items-start">
                                                    <div className="pic"><img src={IMAGE_URL + task?.users_list[0]?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                    <div className="member-info">
                                                        <h4>{task?.task_details?.title}</h4>
                                                        <p>{task?.users_list[0]?.username}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            )}
                        </div>
                    }
                </div>
            </section> */}
            <section className="chats section-bg p-0">
                <InfiniteScroll
                    dataLength={data.length}
                    next={paginate}
                    hasMore={hasMore}
                    loader={<p style={{ textAlign: 'center' }}>
                        <b>Loading...</b>
                    </p>}
                    endMessage={
                        <p style={{ textAlign: 'center' }}>
                            <b>Yay! You have seen it all</b>
                        </p>
                    }
                >
                    <div className="container">
                        <div className="row">
                            {data?.map((task, index) =>
                                <React.Fragment>
                                    <div className="col-lg-3">
                                        <div className='chats-sec' onClick={() => handleClickUserTask(task)} >
                                            <div className="member d-flex align-items-start">
                                                {task?.buyer_unread_count > 0 ?

                                                    <div className='chat-notification-count'>
                                                        <i class="bi bi-chat-dots"><span className='rounded-circle rounded-chat-notification'>{task?.buyer_unread_count}</span></i>
                                                    </div>
                                                    :
                                                    <div className='chat-notification-count'>
                                                        <IoCall color='#37517e' fontSize={"18px"} />
                                                    </div>
                                                }
                                                <div className="pic"><img src={IMAGE_URL + task?.users_list[0]?.image[0]?.image} className="img-fluid" alt="" /></div>
                                                <div className="member-info">
                                                    <div className='task_title_main'>
                                                        <h4>{task?.task_details?.title}</h4>
                                                    </div>
                                                    <span style={{ color: "#1bbaed", fontWeight: "700", fontSize: "16px" }}>{task?.users_list[0]?.username}</span>
                                                    {task?.bid_rate == "" ?
                                                        <>
                                                            <p className='bid_rate_chat'>Chat Rate: {parseFloat(task?.final_amount?.final_chat_rate).toFixed(2)}</p>
                                                            <p className='bid_rate_chat'>Call Rate: {parseFloat(task?.final_amount?.final_call_rate).toFixed(2)}/{task?.time_field == 1 ? "hour" : task?.time_field == 2 && "min"}</p>
                                                        </>

                                                        :
                                                        <>
                                                            <p className='bid_rate_chat'>Bid Rate: {parseFloat(task?.final_amount?.final_amount).toFixed(2)}</p>
                                                        </>
                                                    }
                                                    <p className='bid_rate_chat'>Category: {task?.task_details?.category}</p>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>

                    </div>
                </InfiniteScroll>
            </section>

            {/* <section className="mytask-buyer section-bg p-0">
                <div className="container">
                    <div className="row">
                        {data?.map((task, index) =>
                            <React.Fragment>

                                <div className="col-lg-4">
                                    <div className='mytask-buyer-link' onClick={() => navigate('/chat/' + task?.users_list[0]?.email + task?.task_details?.id + user?.user?.email + task?.task_details?.id, { state: { reciever: task?.users_list[0], task_detail: task?.task_details?.id } })} >
                                        <div className="member d-flex align-items-start">
                                            <div className="pic"><img src={IMAGE_URL + task?.users_list[0]?.image[0]?.image} className="img-fluid" alt="" /></div>
                                            <div className="member-info ms-5">
                                                <h4>{task?.task_details?.title}</h4>
                                                <p><i className="bi bi-calendar me-2"></i> {moment(task?.task_details?.date_choice).format('ll')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                    </div>

                </div>
            </section> */}
            <>
                {/* <Button variant="primary" onClick={handleShow}>
                    Launch demo modal
                </Button> */}

                <Modal className='call_duration_modal' show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        {/* <Modal.Title>Modal heading</Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        <h3 className='call_duration'>Last call duration :</h3>
                        <h3 className='call_charge'>Last call charge :</h3>
                    </Modal.Body>

                    {/* <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleClose}>
                            Save Changes
                        </Button>
                    </Modal.Footer> */}
                </Modal>
            </>
            <Footer />
        </React.Fragment>
    )
}

export default ChatsBuyer;